import React, { Component } from "react";
import { Translation } from "react-i18next";
import { ROOT } from "../../constants";
import { connect } from "react-redux";
import writeCookie from "../../function/writeCookie";
import syteSearch from "../../images/discovery icon.svg";

class Box extends Component {
  state = {
    metalTypeCoverImage: null,
    metalTypeHoverImage: null,
    metalTypeUrl: null,
    metalName2: null,
    price: this.props.data.price,
    originalPrice: this.props.data.originalPrice,
    defaultMetalType: this.props.data.productCode
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.data !== prevProps.data) {
      this.setState({
        metalTypeCoverImage: null,
        metalTypeHoverImage: null,
        metalTypeUrl: null,
        metalName2: null,
        price: this.props.data.price,
        originalPrice: this.props.data.originalPrice,
        defaultMetalType: this.props.data.productCode
      });
    }
  }

  handleMetalType = item => {
    this.setState({
      metalTypeCoverImage: item.imageCover,
      metalTypeHoverImage: item.imageHover,
      metalTypeUrl: item.url,
      metalName2: item.productName2,
      price: item.price,
      originalPrice: item.originalPrice,
      defaultMetalType: item.code
    });
  };

  renderCoverImage = data => {
    const { metalTypeCoverImage } = this.state;
    let image;
    if (data.imageUrl) {
      if (metalTypeCoverImage) {
        image = metalTypeCoverImage;
      } else {
        image = data.imageUrl;
      }
    } else {
      image = "";
    }
    return image;
  };

  renderHoverImage = data => {
    const { metalTypeHoverImage } = this.state;
    let image;
    if (data.imageUrl2) {
      if (metalTypeHoverImage) {
        image = metalTypeHoverImage;
      } else {
        image = data.imageUrl2;
      }
    } else {
      image = "";
    }
    return image;
  };

  pointMarker = () => {
    writeCookie("product-marker", window.pageYOffset);
  };

  renderUrl = data => {
    const { keywords } = this.props;
    const { metalTypeUrl } = this.state;
    let url;
    if (metalTypeUrl) {
      url = `${ROOT}${metalTypeUrl}?searchText=${encodeURIComponent(keywords)}`;
    } else {
      url = `${ROOT}${data.productDetailUrl}?searchText=${encodeURIComponent(
        keywords
      )}`;
    }
    return url;
  };

  isMetalTypeActive = item => {
    const { defaultMetalType } = this.state;
    let isActive;
    if (item.code && item.code === defaultMetalType) {
      isActive = "active";
    } else {
      isActive = "";
    }
    return isActive;
  };

  render() {
    const { data, scale } = this.props;
    const { metalName2, price, originalPrice } = this.state;
    return (
      <div className={`product-result-box pdt_block ${scale ? "box-row" : ""}`}>
        <div className="box-content">
          <a
            href={this.renderUrl(data)}
            onClick={this.pointMarker.bind(this)}
          >
            <div
              className="box-image"
              style={{
                backgroundImage: `url(${this.renderHoverImage(data)})`
              }}
            >
              {data.category && (
                <span className="label-tag">{data.category}</span>
              )}
              <img src={this.renderCoverImage(data)} alt="" />
            </div>
          </a>
          <div className="desc_wrap">
            <div className="collectionName">{data.name}</div>
            <div className="name">{metalName2 ? metalName2 : data.name2}</div>
            {data.saleType &&
            ["normal", "display-show-price", "display-inventory"].includes(
              data.saleType
            ) ? (
              <React.Fragment>
                {price && originalPrice && price !== originalPrice ? (
                  <>
                    <div className="originalPrice_wrap">
                      <div className="price">{originalPrice}</div>
                    </div>
                    <div className="price">{price}</div>
                  </>
                ) : (
                  <>
                    <div className="price">{originalPrice}</div>
                  </>
                )}
              </React.Fragment>
            ) : data.saleType && data.saleType === "display" ? null : null}
          </div>
          <div className="colorOptions_wrap">
            {data.extendMetalTypeList && Array.isArray(data.extendMetalTypeList)
              ? data.extendMetalTypeList.map((item, jndex) => (
                  <span
                    key={jndex}
                    className={`colorOption ${this.isMetalTypeActive(item)}`}
                    onClick={this.handleMetalType.bind(this, item)}
                  >
                    <span
                      className="colorOptions"
                      style={{
                        backgroundImage: `url(${item.thumbnail})`
                      }}
                    />
                  </span>
                ))
              : null}
          </div>
        </div>
        {/* syte 以圖搜圖 search result img*/}
        {/* <button
          class="syte-discovery"
          data-image-src={data.imageUrl}
          data-sku={data.productCode}
          data-placement="product-listing-page"
        >
          <img className="syte-search-icon" src={syteSearch} alt="" />
          <span className="syte-search-tag">
            <Translation>{t => <>{t("searchPage.similarItems")}</>}</Translation>
          </span>
        </button> */}
      </div>
    );
  }
}

Box.defaultProps = {
  data: {
    name: null,
    productDetailUrl: null,
    imageUrl: null,
    imageUrl2: null,
    extendMetalTypeList: null,
    price: null,
    originalPrice: null,
    category: null
  },
  keywords: null
};

const mapStateToProps = state => {
  return {
    scale: state.scaleProduct.scale
  };
};

export default connect(mapStateToProps, null)(Box);
